import { jsx as _jsx } from "react/jsx-runtime";
import { ServicesProvider } from '@abb/services';
import { ABBThemeProvider } from '@abb/uikit';
import App from 'App';
import { customB2BTheme, SERVICES } from 'consts';
import React from 'react';
import { useLocation } from 'react-router-dom';
export const Wrapper = ()=>{
    const { pathname } = useLocation();
    const routes = [
        '/dashboard',
        '/trade-platform'
    ];
    return /*#__PURE__*/ _jsx(ServicesProvider, {
        services: SERVICES,
        children: /*#__PURE__*/ _jsx(ABBThemeProvider, {
            theme: customB2BTheme,
            resetCSS: !routes.some((route)=>pathname.includes(route)),
            children: /*#__PURE__*/ _jsx(App, {})
        })
    });
};
